<template>
   <nearest-stores :store="store"></nearest-stores>
</template>

<script>
import NearestStores from '@/components/NearestStores'
import ServiceDrupal from '@/services/ServiceDrupal.js'

export default {
    name: 'nearest-stores-app',
    data () {
        return {
            store: null
        }
    },
    components: {
        NearestStores
    },
    beforeMount () {
        this.store = ServiceDrupal.getStore()
    }
}
</script>
